<template>
    <b-card
        :title="formTitle"
        @cancel="
            () => {
                addWebhooksSlide ? slideIt('cancel') : closeModal();
            }
        "
        @submit="
            () => {
                addWebhooksSlide
                    ? slideIt('save')
                    : submitModal(webhook.store_event_id);
            }
        "
        :loading="loading"
        :submit-text="
            addWebhooksSlide ? translations.addEvents : translations.save
        "
        :cancel-text="translations.cancel"
        stickyFooter
    >
        <v-window v-model="addWebhooksSlide">
            <v-window-item>
                <v-row no-gutters>
                    <v-col md="12"
                        ><span class="">{{
                            translations.selectEventsToListen[lang]
                        }}</span></v-col
                    >
                    <v-col cols="12" class="pr-2">
                        <v-chip-group column class="event-chips">
                            <v-chip
                                v-for="(eventId,
                                index) in webhookData.event_types"
                                :key="index"
                                class="font-weight-bold px-1 pr-2 pl-2"
                                style="overflow: visible;"
                                close
                                @click:close="removeSelectedEvent(eventId)"
                            >
                                {{ getEventType(eventId) }}
                            </v-chip>
                        </v-chip-group>

                        <!-- <div v-else-if="data.index === 0">
                                <span>{{ webhookData.event_types
                                    .length }}</span> {{ translations.eventsSelected[lang] }}
                        </div> -->

                        <v-col v-if="error.events" md="12 pt-0 pb-0"
                            ><span style="color: red;" class="">{{
                                error.events
                            }}</span></v-col
                        >
                        <v-btn
                            class="mx-2 mb-3 mt-2 pt-1 pb-1 text-capitalize"
                            outlined
                            depressed
                            rounded
                            small
                            @click="slideIt"
                        >
                            <span
                                v-if="!webhookData.event_types.length"
                                class="d-flex align-center"
                            >
                                <v-icon left>
                                    mdi-plus
                                </v-icon>
                                <span>{{
                                    translations.selectEvents[lang]
                                }}</span>
                            </span>

                            <span v-else class="d-flex align-center">
                                <v-icon left>
                                    mdi-pencil
                                </v-icon>
                                {{ translations.editEvents[lang] }}
                            </span>
                        </v-btn>
                    </v-col>

                    <v-col cols="12" class="pr-2">
                        <b-text-field
                            :label="'URL'"
                            v-model="webhookData.endpoint_url"
                            :success="success.url"
                            :error-messages="error.url"
                            @blur="validateUrl"
                        ></b-text-field>
                    </v-col>

                    <v-col cols="12" class="pr-2">
                        <b-text-field
                            :label="translations.description[lang]"
                            v-model="webhookData.description"
                        ></b-text-field>
                    </v-col>

                    <v-col cols="12" class="pr-2">
                        <v-checkbox
                            color="secondary"
                            class="mt-3 pt-0"
                            hide-details
                            v-model="enableAuth"
                        >
                            <template v-slot:label>
                                <h4 class="subtitle-2">
                                    {{ translations.enableAuth[lang] }}
                                </h4>
                            </template>
                        </v-checkbox>
                    </v-col>

                    <v-col cols="12" v-if="enableAuth">
                        <v-col cols="12" class="pr-2">
                            <v-select
                                menu-props="offsetY"
                                color="secondary"
                                item-color="secondary"
                                :loading="loading"
                                clearable
                                outlined
                                dense
                                open-on-clear
                                hide-details="auto"
                                :items="authTypes"
                                item-text="name"
                                v-model="selectedAuth"
                                :label="translations.authorization[lang]"
                                return-object
                            >
                                <!-- <template v-slot:selection="{ item }">
                            {{ Object.keys(item)[0] }}
                        </template>
                        <template v-slot:item="{ item }">
                            {{ Object.keys(item)[0] }}
                        </template> -->
                            </v-select>
                        </v-col>

                        <v-col
                            v-if="webhookData.authorization"
                            class="d-flex justify-center pt-0"
                        >
                            <v-col
                                cols="6"
                                v-if="
                                    webhookData.authorization.basic !==
                                        undefined
                                "
                                class="pr-2 pt-0"
                            >
                                <b-text-field
                                    label="Username"
                                    v-model="
                                        webhookData.authorization.basic.username
                                    "
                                ></b-text-field>
                            </v-col>
                            <v-col
                                cols="6"
                                v-if="
                                    webhookData.authorization.basic !==
                                        undefined
                                "
                                class="pr-2 pt-0"
                            >
                                <b-text-field
                                    label="Password"
                                    v-model="
                                        webhookData.authorization.basic.password
                                    "
                                ></b-text-field>
                            </v-col>
                            <v-col
                                cols="6"
                                v-if="
                                    webhookData.authorization.api !== undefined
                                "
                                class="pr-2 pt-0"
                            >
                                <b-text-field
                                    label="Key"
                                    v-model="webhookData.authorization.api.key"
                                ></b-text-field>
                            </v-col>
                            <v-col
                                cols="6"
                                v-if="
                                    webhookData.authorization.api !== undefined
                                "
                                class="pr-2 pt-0"
                            >
                                <b-text-field
                                    label="Value"
                                    v-model="
                                        webhookData.authorization.api.value
                                    "
                                ></b-text-field>
                            </v-col>
                            <v-col
                                cols="12"
                                v-if="
                                    webhookData.authorization.bearer !==
                                        undefined
                                "
                                class="pr-2 pt-0"
                            >
                                <b-text-field
                                    label="Token"
                                    v-model="
                                        webhookData.authorization.bearer.token
                                    "
                                ></b-text-field>
                            </v-col>
                        </v-col>
                    </v-col>

                    <v-col cols="12" class="pr-2">
                        <v-checkbox
                            color="secondary"
                            class="mt-3 pt-0"
                            hide-details
                            v-model="webhookData.enable"
                        >
                            <template v-slot:label>
                                <h4 class="subtitle-2">
                                    {{ translations.enableOnSave[lang] }}
                                </h4>
                            </template>
                        </v-checkbox>
                    </v-col>
                </v-row>
            </v-window-item>
            <v-window-item class="pb-3">
                <v-btn
                    class="mx-2 mb-3 pt-1 pb-1 text-capitalize ml-0 pl-2"
                    style="border:none"
                    outlined
                    depressed
                    rounded
                    small
                    @click="slideIt"
                >
                    <span class="d-flex align-center">
                        <v-icon left>
                            mdi-arrow-left
                        </v-icon>
                        <span>{{ translations.cancel[lang] }}</span>
                    </span>
                </v-btn>
                <v-row justify="center" class="mt-3">
                    <v-expansion-panels focusable>
                        <v-expansion-panel
                            v-for="(item, i) in categorizedEvents"
                            :key="i"
                            class="mb-2"
                        >
                            <v-expansion-panel-header>
                                <template v-slot:actions>
                                    <v-icon color="primary">
                                        $expand
                                    </v-icon>
                                </template>
                                <span class="text-capitalize">
                                    <!-- <v-badge
                                            color="green"
                                            :content="item.events.filter(x => selectedEvents.includes(x.id)).length + ' ' + translations.selected[lang]"
                                            class="mt-2"
                                            > -->
                                    {{ item.name }}
                                    <!-- </v-badge> -->
                                    <span
                                        v-if="
                                            item.events.filter(x =>
                                                selectedEvents.includes(x.id)
                                            ).length > 0
                                        "
                                        class="text-caption font-weight-medium count-selected-txt ml-2 pa-1 pl-2 pr-2"
                                        >{{
                                            item.events.filter(x =>
                                                selectedEvents.includes(x.id)
                                            ).length +
                                                " " +
                                                translations.selected[lang]
                                        }}</span
                                    >
                                </span>
                                <span class="d-flex justify-end pr-4">
                                    <v-checkbox
                                        v-model="item.selectAll"
                                        :label="translations.selectAll[lang]"
                                        @click.native.stop="
                                            selectAllEvents(item.name)
                                        "
                                    ></v-checkbox>
                                </span>
                            </v-expansion-panel-header>
                            <v-expansion-panel-content>
                                <v-row class="mt-1">
                                    <v-col cols="12" md="12" sm="12">
                                        <v-container
                                            v-for="(event, ei) in item.events"
                                            :key="event.id"
                                            style="max-height: 55px"
                                            :class="[!ei && 'mt-n5']"
                                        >
                                            <v-checkbox
                                                v-model="selectedEvents"
                                                :label="event.name"
                                                :value="event.id"
                                            ></v-checkbox>
                                        </v-container>
                                    </v-col>
                                </v-row>
                                <!-- <v-col cols="12" md="12" class="pa-0">
                                        <v-toolbar flat>
                                            <v-spacer></v-spacer>
                                            <v-btn
                                                type="submit"
                                                :color="'secondary'"
                                                class="text-capitalize px-5"
                                                style="font-size: 0.9rem"
                                                depressed
                                                :loading="loading"
                                                @click="slideIt"
                                                >{{ translations.save[lang] }}
                                            </v-btn>
                                        </v-toolbar>
                                    </v-col> -->
                            </v-expansion-panel-content>
                        </v-expansion-panel>
                    </v-expansion-panels>
                </v-row>
            </v-window-item>
        </v-window>
    </b-card>
</template>

<script>
import { mdiPlus, mdiMenuUp, mdiMenuDown } from "@mdi/js";
import { mapMutations, mapState, mapActions, mapGetters } from "vuex";
import validators from "@/utils/validators/general/settings/developers/webhook";
import translations from "@/utils/translations/general/settings/developers";
import { cloneDeep } from "lodash";

export default {
    name: "WebhookForm",

    mixins: [translations, validators],

    components: {},
    props: {
        isOpen: {
            type: Boolean,
            default: true
        }
    },
    data() {
        return {
            icons: {
                mdiPlus,
                mdiMenuUp,
                mdiMenuDown
            },
            authTypes: [
                {
                    system: "basic",
                    name: "Basic Auth",
                    options: { username: "", password: "" }
                },
                {
                    system: "api",
                    name: "API Key",
                    options: { key: "", value: "" }
                },
                {
                    system: "bearer",
                    name: "Bearer Token",
                    options: { token: "" }
                }
            ],
            selectedAuth: {},
            enableAuth: false,
            webhookData: { event_types: [], authorization: {} },
            toggleSelect: false,
            addWebhooksSlide: 0,
            selectedEvents: []
        };
    },
    computed: {
        ...mapState(["loading", "errorMessage", "superUser"]),

        ...mapState("general/settings/developers/webhooks", [
            "events",
            "webhooks"
        ]),

        lang() {
            return this.$route.params.lang;
        },

        locale() {
            if (this.lang == "el") return "el-GR";
            if (this.lang == "it") return "it-IT";
            return "en-GB";
        },

        webhook: {
            get() {
                return this.$store.state.general.settings.developers.webhooks
                    .webhook;
            },
            set(val) {
                this.setWebhook(val);
            }
        },

        formTitle() {
            return this.webhook?.store_event_id
                ? this.translations.updateWebhook[this.lang]
                : this.translations.createWebhook[this.lang];
        },

        webhookAuthName() {
            return Object.keys(this.webhook.authorization || {})?.[0] || "";
        },

        categorizedEvents() {
            return this.events.reduce((a, c) => {
                let cat = c.type?.split(".")[0];
                let event = c.type?.substring(cat.length + 1);
                let catObj = a.find(x => x.name == cat);
                let eventObj = {
                    name: event,
                    id: c.id,
                    description: c.description || ''
                };
                if (!catObj) {
                    return [
                        ...a,
                        {
                            name: cat,
                            events: [eventObj],
                            selectAll: false
                        }
                    ];
                } else {
                    catObj.events.push(eventObj);
                    return a;
                }
            }, []);
        }
    },

    watch: {
        webhook: {
            immediate: true,
            handler(val) {
                if (val.store_event_id) {
                    this.webhookData = cloneDeep(val);
                    this.enableAuth = !!val.authorization;
                    if (this.enableAuth) {
                        this.selectedAuth.system = this.webhookAuthName || "";
                    }
                } else {
                    this.webhookData = { event_types: [], authorization: {} };
                }
                this.resetValidation();
            },
            deep: true
        },

        selectedAuth: {
            immediate: true,
            handler(val) {
                if (val?.system) {
                    // let type = this.authTypes.find(x => x.system == val.system)
                    this.webhookData.authorization = {
                        [val.system]: val.options
                    };
                    if (val.system == this.webhookAuthName) {
                        this.webhookData.authorization[
                            val.system
                        ] = this.webhook.authorization[val.system];
                    }
                }
            },
            deep: true
        },

        errorMessage: {
            handler(val) {
                if (val) {
                    this.setNotification({
                        show: true,
                        type: "error",
                        text: val
                    });
                }
            }
        },

        selectedEvents: {
            immediate: true,
            handler(val) {
                if (Array.isArray(val)) {
                    this.categorizedEvents.forEach(c => {
                        c.selectAll = c.events?.length;
                        if (c.selectAll) {
                            c.events.forEach(e => {
                                if (!val.includes(e.id)) {
                                    c.selectAll = false;
                                }
                            });
                        }
                    });
                }
            },
            deep: true
        },

        isOpen: {
            handler(val) {
                if (!val) {
                    this.closeModal();
                } else {
                    if (this.webhookData.event_types.length) {
                        this.selectedEvents = cloneDeep(
                            this.webhookData.event_types
                        );
                    }
                }
            }
        }
    },

    methods: {
        ...mapActions("general/settings/developers/webhooks", [
            "getAllEvents",
            "getAllWebhooks",
            "getWebhook",
            "createWebhook",
            "updateWebhook"
        ]),

        ...mapMutations(["setDeleteDialog", "setNotification", "setLoading"]),
        ...mapMutations("general/settings/developers/webhooks", ["setWebhook"]),

        localizeDate(date, short) {
            return date
                ? new Date(date).toLocaleString(this.locale, {
                      weekday: short ? undefined : "long",
                      year: "numeric",
                      month: short ? "numeric" : "long",
                      day: "numeric"
                  })
                : "-";
        },

        closeModal() {
            this.selectedEvents = [];
            this.addWebhooksSlide = 0;
            this.$emit("close");
        },

        async submitModal(id) {
            this.validateEvents();
            this.validateUrl()
            if (!this.formValid) return false;
            let body = { ...this.webhookData };
            if(!body.description)body.description = undefined
            if (!this.enableAuth) {
                body.authorization = null;
            }
            if (id) {
                body.enable = !!this.webhookData.enable;
                await this.updateWebhook({ id, body });
            } else {
                await this.createWebhook(body);
            }
            this.resetValidation();
            this.closeModal();
        },

        slideIt(e) {
            if (e == "cancel") {
                this.selectedEvents = [...this.webhookData.event_types];
            }
            if (e == "save") {
                this.webhookData.event_types = [...this.selectedEvents];
                this.validateEvents();
            }
            if (this.webhookData.event_types.length) {
                this.selectedEvents = cloneDeep(this.webhookData.event_types);
            }
            this.addWebhooksSlide = this.addWebhooksSlide ? 0 : 1;
        },

        getEventType(id) {
            return ((this.events || []).find(x => x.id == id) || {}).type || "";
        },

        removeSelectedEvent(id) {
            this.webhookData.event_types = this.webhookData.event_types.filter(
                e => e != id
            );
            this.selectedEvents = [...this.webhookData.event_types];
        },

        selectAllEvents(catName) {
            let cat = this.categorizedEvents.find(x => x.name == catName);
            cat.events.forEach(e => {
                if (cat.selectAll) {
                    if (!this.selectedEvents.includes(e.id)) {
                        this.selectedEvents.push(e.id);
                    }
                } else {
                    if (this.selectedEvents.includes(e.id)) {
                        this.selectedEvents = this.selectedEvents.filter(
                            x => x != e.id
                        );
                    }
                }
            });
        }
    },

    mounted() {}
};
</script>
<style>
.count-selected-txt {
    background: rgba(5, 220, 81, 0.87);
    border-radius: 18px;
    color: rgb(0, 83, 42);
}
</style>
